var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7436_12740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 20.1654C16.0628 20.1654 20.1668 16.0613 20.1668 10.9987C20.1668 5.93609 16.0628 1.83203 11.0002 1.83203C5.93755 1.83203 1.8335 5.93609 1.8335 10.9987C1.8335 16.0613 5.93755 20.1654 11.0002 20.1654Z",
    stroke: "#103A5D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 9.625L11.0002 13.2917L14.6668 9.625",
    stroke: "#103A5D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7436_12740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/drop-down-icon.57673f395fe6843da26ef31abdb7a0c0.svg";
export { ForwardRef as ReactComponent };